export const INTERVIEW_ASSESSOR = "INTERVIEW_ASSESSOR";
export const INTERVIEW_ASSESSEE = "INTERVIEW_ASSESSEE";
export const LGD_ASSESSOR = "LGD_ASSESSOR";
export const LGD_ASSESSEE = "LGD_ASSESSEE";
export const FGD_ASSESSOR = "FGD_ASSESSOR";
export const FGD_ASSESSEE = "FGD_ASSESSEE";
export const PRESENTASI_ASSESSOR = "PRESENTASI_ASSESSOR";
export const PRESENTASI_ASSESSEE = "PRESENTASI_ASSESSEE";
export const ROLEPLAY_ASSESSOR = "ROLEPLAY_ASSESSOR";
export const ROLEPLAY_ASSESSEE = "ROLEPLAY_ASSESSEE";
export const CA_ASSESSEE = "CA_ASSESSEE";
export const CA_ASSESSOR = "CA_ASSESSOR";
export const GENERAL = "GENERAL";

export const PAGE_INTERVIEW_ASSESSOR = "interview-assessor";
export const PAGE_INTERVIEW_ASSESSEE = "interview-assessee";
export const PAGE_LGD_ASSESSOR = "lgd-assessor";
export const PAGE_LGD_ASSESSEE = "lgd-assessee";
export const PAGE_FGD_ASSESSOR = "fgd-assessor";
export const PAGE_FGD_ASSESSEE = "fgd-assessee";
export const PAGE_PRESENTASI_ASSESSOR = "presentasi-assessor";
export const PAGE_PRESENTASI_ASSESSEE = "presentasi-assessee";
export const PAGE_ROLEPLAY_ASSESSOR = "roleplay-assessor";
export const PAGE_ROLEPLAY_ASSESSEE = "roleplay-assessee";
export const PAGE_CA_ASSESSEE = "ca-assessee";
export const PAGE_CA_ASSESSOR = "ca-assessor";
export const PAGE_GENERAL = "general";

export const UI_MODE = (val) => {
  switch (val) {
    case INTERVIEW_ASSESSOR:
      return PAGE_INTERVIEW_ASSESSOR;
    case INTERVIEW_ASSESSEE:
      return PAGE_INTERVIEW_ASSESSEE;
    case LGD_ASSESSOR:
      return PAGE_LGD_ASSESSOR;
    case LGD_ASSESSEE:
      return PAGE_LGD_ASSESSEE;
    case FGD_ASSESSOR:
      return PAGE_FGD_ASSESSOR;
    case FGD_ASSESSEE:
      return PAGE_FGD_ASSESSEE;
    case PRESENTASI_ASSESSOR:
      return PAGE_PRESENTASI_ASSESSOR;
    case PRESENTASI_ASSESSEE:
      return PAGE_PRESENTASI_ASSESSEE;
    case ROLEPLAY_ASSESSOR:
      return PAGE_ROLEPLAY_ASSESSOR;
    case ROLEPLAY_ASSESSEE:
      return PAGE_ROLEPLAY_ASSESSEE;
    case CA_ASSESSOR:
      return PAGE_CA_ASSESSOR;
    case CA_ASSESSEE:
      return PAGE_CA_ASSESSEE;

    default:
      return PAGE_GENERAL;
  }
};
